const mapResponse = (response) =>
    response
        .json()
        .catch((e) => {
            // eslint-disable-next-line
            throw {
                statusCode: response.status,
                headers: response.headers,
                error: null,
            }; // eslint-disable-line no-throw-literal
        })
        .then((json) => {
            if (response.ok) {
                return json;
            }
            // eslint-disable-next-line
            throw {
                statusCode: response.status,
                headers: response.headers,
                error: json,
            }; // eslint-disable-line no-throw-literal
        });

const callApi = (request) => {
    const transformedRequest = {
        ...request,
        headers: { 'Content-Type': 'application/json' },
    };

    return fetch(request.url, transformedRequest).then(mapResponse);
};

export const getDefaultFacilityByLocation = (jsonObject) => async () => {
    let response;

    try {
        response = await callApi({
            url: `/api/projects/defaultfacility`,
            method: 'POST',
            body: JSON.stringify(jsonObject),
        });
    } catch (error) {
        return null;
    }
    return response;
};
